import React from "react";
import FooterNavigation from "../FooterNavigation/FooterNavigation"
import SocialNavigation from "../SocialNavigation/SocialNavigation"
import { Wrapper } from "./Footer.styles"
import { useFooterQuery } from "../../hooks/useFooterQuery"
import { useSocialMediaQuery } from "../../hooks/useSocialMediaQuery"

import Logo from "../../images/thekinetixgroup-logo.svg"
import Badge from "../../images/Certification_Badge.png"

import 'twin.macro'

const Footer = ()=> {

    const data = useFooterQuery();
    const socialmedia = useSocialMediaQuery();


    return(
        <Wrapper className="main-footer">
            <div className="box">
                <div className="left-block">
                    <p className="brand-name">Petauri Kinect</p>
                    <p className="desktop-only">© 2024 Petauri Kinect. All rights reserved.<br/>
                    29 Broadway, 26th Floor, New York, NY 10006</p>
                </div>

                <div className="right-block">

                    <div className="content-block">
                        <SocialNavigation menu={socialmedia}/>
                        <FooterNavigation menu={data}/>
                        <small className="mobile-only">© 2022 The Kinetix Group. All rights reserved.<br/>
                        29 Broadway, 26th Floor, New York, NY 10006</small>
                    </div>

                    <div tw="sm:ml-14">
                        <img srcSet={`${Badge} 2x`} alt="Great Place To Work&reg; Certified, May 2022 - May 2023 | USA"/>
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}

export default Footer;